import { color } from '@upstox/upstox-ui';

export const headerCell: CSSFunction = ({ theme }) => ({
  width: '100px',
  height: '36px',
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '24px',
  color: color(theme, theme.colors.text[2]),
  backgroundColor: color(theme, theme.colors.ui2),
  textAlign: 'center',
  fontFamily: 'Messina Sans',
  verticalAlign: 'middle',
  boxShadow: `inset 0 -1px 0 ${color(theme, theme.colors.ui3)}`,
});
